module.exports = __webpack_public_path__ + "img/microphone.13a8492c.jpg";